/**
 * A mixin for SpotEntry and SpotDecoderEntry to update their preview
 * when a 'refetch-on-content-processed' websocket event for a relavant
 * EditableTVSpotVideo comes in.
 *
 * Depends on:
 * - this.entry
 * - The parent container to refetch on: this.$emit('change')
 */
export default {
  methods: {
    /**
     * Install websocket listener when this.entry refers to an HTML-Spot.
     *
     * Otherwise do nothing.
     */
    maybeRefetchDecoderOnContentProcessedEvent() {
      const shouldListenToEditableTVSpotVideoProcessedEvents =
        this.entry.ctype === 'tv' && this.entry.spot.editable_template;
      if (!shouldListenToEditableTVSpotVideoProcessedEvents) {
        return;
      }

      this.$bus.$on('refetch-on-content-processed', (content) => {
        if (
          content.kind === 'editabletvspotvideo' &&
          content.entry_idents.indexOf(this.entry.ident) !== -1
        ) {
          console.log(
            '[DEBUG] The video that this entry needs has processed, ' +
              'trigger a refetch to update the preview'
          );
          this.$emit('changed');
        }
      });
    },
  },
};



// WEBPACK FOOTER //
// ./src/mixins/spotentryUpdateOnContentProcessed.js